// extracted by mini-css-extract-plugin
export default {"box":"Box_box__8i9Ur"};